import { render, staticRenderFns } from "./MinutFilm.vue?vue&type=template&id=7232e836"
import script from "./MinutFilm.vue?vue&type=script&lang=js"
export * from "./MinutFilm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports